import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "tariffOptionsTable",
  class: "o-grid"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }
const _hoisted_3 = {
  key: 0,
  class: "u-form-heading unset-text-align"
}
const _hoisted_4 = { class: "tarifoptions-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tarifoption = _resolveComponent("tarifoption")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.props.tarifoptionentitel === undefined)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.piniaStore.state.isMakler ? "Tarifmerkmale" : "Tarifoptionen"), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tarifOptionData, (tarifoptionInformation) => {
        return (_openBlock(), _createBlock(_component_tarifoption, {
          key: tarifoptionInformation.typ,
          tarifoptionInformation: tarifoptionInformation,
          "ist-letzte-tarifoption": _ctx.istLetzteSichtbareTarifoption(tarifoptionInformation.typ),
          tarifoptionentitel: _ctx.props.tarifoptionentitel
        }, null, 8, ["tarifoptionInformation", "ist-letzte-tarifoption", "tarifoptionentitel"]))
      }), 128))
    ])
  ], 64))
}